import React, { FC } from 'react'
import { EGG } from '@shared/api/analytics'
import { Text } from '@shared/ui/Typography/Text'
import s from '@widgets/Common/Footer/Footer.module.sass'
import Link from 'next/link'

export const FooterMeta: FC = () => {
  const handleClickRecommendationTech = () => {
    EGG.footer.menu_item_click({ button_name: 'recommendation technologies' })
  }
  const handleClickUserAgreement = () => {
    EGG.footer.menu_item_click({ button_name: 'user agreement' })
  }

  const handleClickPrivacyPolicy = () => {
    EGG.footer.menu_item_click({ button_name: 'privacy policy' })
  }

  return (
    <Text sizes={'S'} className={s.privacy}>
      <Link
        href='https://www.afisha.ru/article/pravila-primeneniya-rekomendatelnyh-tehnologiy/'
        className={s['meta-link']}
        target='_blank'
        onClick={handleClickRecommendationTech}
        scroll={false}>
        На информационном ресурсе применяются рекомендательные технологии в соответствии с Правилами.
      </Link>{' '}
      <Link
        href={'https://www.afisha.ru/article/usloviya-ispolzovaniya/'}
        className={s['meta-link']}
        target='_blank'
        onClick={handleClickUserAgreement}
        scroll={false}>
        Условия использования{', '}
      </Link>
      <Link href='https://www.afisha.ru/article/privacy-policy/' target='_blank' onClick={handleClickPrivacyPolicy}>
        Политика конфиденциальности{' '}
      </Link>
      <span>© ООО «Компания Афиша» 1999–2025. 18+</span>
    </Text>
  )
}
